module.exports = __webpack_public_path__ + "img/u2835.bfc10ea6.jpg";